import { useContext, useState } from "react";
import { MyContext } from "../../context";
//import OverviewBatteryFeatures from "./OverviewBatteryFeature";
//import Searches from "./Search";
//import ClientSettingCode from "./ClientSettingCode";
import Uploading from "./Upload"

function ClientSettingPersonalInfo() {
  const {
    userName,
    usersEmail,
    RightLinkSelection,
    updateRightLinkSelection,
    updateInstallationLinkSelection,
    Phone,
    Profile_url
  } = useContext(MyContext);

  const [isModalOpen, setIsModalOpen] = useState(false);

  const OpenImageModal = () => {
    setIsModalOpen(true);
  }

  const closeModal = () => {
    setIsModalOpen(false);
  };






  return (
    <>
      <div className="col-sm-7">
        <div className="card" style={{ width: "18rem;" }}>
          <div className="card-body">

            
            {/*
            <div style={{ display: "flex" }}>
              <p className="card-title">
                <strong>Personal Information</strong>
              </p>
              <span className="info leftAling">
                <span class="material-symbols-rounded">more_horiz</span>
              </span>
            </div> 

            <hr />*/}
            
            <div onClick={OpenImageModal}>
              <img
                src={Profile_url}
                width={"165px"}
                height={"165px"}
                alt="Profile_image"
                className="topAvatar"
                style={{display:"flex", margin:"auto", border:"10px solid #fff", marginTop:"-40px"}}
              />
            </div>
           
            <hr />

           

            <div style={{ display: "flex" }}>
              <div
                className="smallInfo"
                style={{ display: "flex", marginBottom: "20px" }}
              >
                <span
                  class="material-symbols-rounded"
                  style={{ marginRight: "5px", color: "#e0632d" }}
                >
                  person
                </span>
                <span
                  style={{
                    marginTop: "2px",
                    paddingLeft: "5px",
                    width: "250px",
                  }}
                >
                  {userName}
                </span>
              </div>

              <div
                className="smallInfo"
                style={{ display: "flex", marginBottom: "20px" }}
              >
                <span
                  className="material-symbols-rounded"
                  style={{ marginRight: "5px", color: "#e0632d" }}
                >
                  mail
                </span>
                <span
                  style={{
                    marginTop: "2px",
                    paddingLeft: "5px",
                    width: "250px",
                  }}
                >
                  {usersEmail}
                </span>
              </div>


              <div
                className="smallInfo"
                style={{ display: "flex", marginBottom: "20px" }}
              >
                <span
                  className="material-symbols-rounded"
                  style={{ marginRight: "5px", color: "#e0632d" }}
                >
                  phone
                </span>
                <span
                  style={{
                    marginTop: "2px",
                    paddingLeft: "5px",
                    width: "250px",
                  }}
                >
                 {Phone}
                </span>
              </div>

             
            </div>

            <div style={{ display: "flex" }}>
              <div
                className="smallInfo"
                style={{ display: "flex", marginBottom: "20px" }}
              >
                <span
                  className="material-symbols-rounded"
                  style={{ marginRight: "5px", color: "#e0632d" }}
                >
                  location_on
                </span>

                <span
                  style={{
                    marginTop: "2px",
                    paddingLeft: "5px",
                    width: "250px",
                  }}
                >
                  
                    3504 Pimville Zone 3 / Johannesburg / Guateng / South Africa{" "}
                  
                </span>
              </div>

              <div
                className="smallInfo"
                style={{ display: "flex", marginBottom: "20px" }}
              >
                <span
                  className="material-symbols-rounded"
                  style={{ marginRight: "5px", color: "#e0632d" }}
                >
                  event
                </span>

                <span
                  style={{
                    marginTop: "2px",
                    paddingLeft: "5px",
                    width: "250px",
                  }}
                >
                  15 May 1988 
                </span>
              </div>




            </div>


            <div style={{ display: "flex" }}>
              
                  </div>

                  
{/*Modal*/}
{isModalOpen && (
        <div className="modal fade show" style={{ display: 'block' }}>
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
              <span class="material-symbols-rounded">image</span> 
                <button type="button" className="close" onClick={closeModal}>
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div className="modal-body">
                { <Uploading />}
              </div>
           
            </div>
          </div>
        </div>
      )}

      {isModalOpen && <div className="modal-backdrop fade show"></div>}
{/*End Modal*/}


          </div>
        </div>
      </div>
    </>
  );
}

export default ClientSettingPersonalInfo;
